export default "__VITE_ASSET__9d92cbfe__"